import { LitElement, html, css } from 'lit';
import { validateForm } from '../../utilities/formsUtilities';
import { accessibility, formStyles } from '../../utilities/styles';
export class AllInEmailConfirmation extends LitElement {
    static properties = {
        _confirmation: { type: String, state: true },
        resturl: { type: String },
        nonce: { type: String },
        config_hardlinks: { type: Object, reflect: true },
        supportEmail: { type: String },
        verifyEmailLink: { type: String },
    };
    constructor() {
        super();
        this.supportEmail = 'https://allin.zendesk.com/hc/en-gb/articles/4945686282143-Contact-us';
        this.verifyEmailLink = '/verify-your-email/';
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        let queryString = window.location.search;
        let params = new URLSearchParams(queryString);
        this.token = params.get('token_hash');
        if (this.token) {
            this.message = html `\n                <h3>Cadarnhad E-bost</h3>\n                <button @click="${this.handleVerification}" class="button decorative">Cwblhau eich proses gadarnhau</button>\n                <p class="resend-verify-email">Dolen cadarnhau e-bost wedi dod i ben? <a href="${this.verifyEmailLink}" target="_blank">Anfon eich e-bost cadarnhau eto</a> neu <a href="${this.supportEmail}">cysylltu \u00E2 ni</a>.</p>\n            `;
        }
        else {
            let confirmation_message = window.location.hash;
            if (confirmation_message && confirmation_message.includes('otp_expired')) {
                this.message = html `<p>Mae\u2019r ddolen y gwnaethoch chi ei dilyn wedi dod i ben.</p>\n                    <p>Os nad oeddech chi\u2019n disgwyl i\u2019r ddolen hon ddod i ben, cysylltwch \u00E2\u2019ch adran TG i weld a yw\u2019r parth hwn (https://allin.online) ar y rhestr a ganiateir.</p>\n                    <p><a href="${this.config_hardlinks.verify_your_email}">Gofynnwch am un newydd</a></p>`;
                this.header = `Dolen wedi Dod i Ben`;
                let header = document.querySelector('h1');
                if (header) {
                    header.innerHTML = this.header;
                }
            }
            else {
                this.message = html `<p>Mae eich e-bost wedi cael ei gadarnhau</p><p><a href="${this.config_hardlinks.login}">Mewngofnodwch i\u2019ch cyfrif</a></p>`;
            }
        }
    }
    render() {
        if (this._confirmation) {
            return html `\n                <div class="">\n                    <div class="bg">\n                        <h3>Cadarnhad E-bost</h3>\n                        <p>${this._confirmation}</p>\n                    </div>\n                </div>\n            `;
        }
        return html ` \n            <div class="">\n                <div class="bg">\n                    ${this.message}\n                </div>\n            </div>\n        `;
    }
    handleVerification() {
        if (this.token) {
            fetch(this.resturl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Verify': 'verify',
                },
                body: JSON.stringify({ token_hash: this.token }),
            })
                .then(response => response.json())
                .then(data => {
                if (data.ok) {
                    this._confirmation = data.message;
                    window.location.href = data.redirect;
                }
                else {
                    this._confirmation = html `Gwall wrth gadarnhau eich e-bost. <a href="${this.config_hardlinks.verify_your_email}">Gofyn am gadarnhad e-bost newydd.</a>`;
                }
            })
                .catch(error => {
                console.error('Error:', error);
            });
        }
    }
}
